/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiTheme from '@here/lui-base/lui-theme'

export default class LuiDefaultTheme extends LuiTheme {
  static get is() {
    return 'lui-default-theme'
  }

  static get attributeToggles() {
    return ['dark', 'light', 'hds-light', 'hds-dark']
  }

  static get addOwnCssToThemeCascade() {
    return false
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-layer-theme/lui-default-theme.js
// module id = 151
// module chunks = 0 1 19